import { useMemo } from 'react'

import { TitleDocument } from '@/pages/DocumentPage/components/TitleDocument'
import { OperationDocument } from '@/pages/DocumentPage/components/OperationDocument'
import { BillOfMaterialsTable } from '@/pages/DocumentPage/components/OperationDocument/BillOfMaterialsTable'
import { ToolsBillOfMaterialsTable } from '@/pages/DocumentPage/components/OperationDocument/ToolsBillOfMaterialsTable'
import { Spinner } from '@/components/ui/spinner'

import { useTechnicianDocument } from '../hooks/useTechnicianDocument'
import { useDocumentPageQuery } from '@/pages/DocumentPage/queries'
import { useListPageViews } from '@/services/queries/views'

export const DocumentPage = () => {
  const { isLoading, data } = useDocumentPageQuery()
  const { currentPage } = useTechnicianDocument()

  const { isLoading: isLoadingViews, data: viewsData } = useListPageViews({
    cadVersionId: data?.version?.id,
    documentVersionId: data?.documentVersion?.id,
  })

  const views = useMemo(
    () =>
      (viewsData || [])
        .filter((view) => view.document_page === currentPage.id)
        .sort((viewA, viewB) => {
          return (
            (viewA.document_page_order || 0) - (viewB.document_page_order || 0)
          )
        }),
    [viewsData, currentPage.id],
  )

  if (isLoading || isLoadingViews) {
    return (
      <div className="relative bg-white flex flex-col justify-between h-[612px] w-full">
        <Spinner />
      </div>
    )
  }

  if (!data) {
    return null
  }

  const versionNumber = data.documentVersion?.version_number || 1
  const versionName = data.documentVersion?.name || `V${versionNumber}`
  const createdAt = data.documentVersion?.created || new Date().toISOString()
  const isLatestDocumentVersion = false
  const documentName = data.doc?.name || 'Work Instructions'

  if (currentPage.type === 'title') {
    return (
      <TitleDocument
        parentRef={null}
        documentName={documentName}
        versionName={versionName}
        createdAt={createdAt}
        isLatestDocumentVersion={isLatestDocumentVersion}
      />
    )
  }

  if (currentPage.type === 'parts-bom') {
    return (
      <BillOfMaterialsTable
        rows={currentPage.rows || ([] as any)}
        versionName={versionName}
        createdAt={createdAt}
        isLatestDocumentVersion={isLatestDocumentVersion}
      />
    )
  }

  if (currentPage.type === 'tools-bom') {
    return (
      <ToolsBillOfMaterialsTable
        rows={currentPage.rows || ([] as any)}
        versionName={versionName}
        createdAt={createdAt}
        isLatestDocumentVersion={isLatestDocumentVersion}
      />
    )
  }

  if (currentPage) {
    return (
      <OperationDocument
        key={currentPage.id}
        documentPage={currentPage as any}
        views={views}
        versionName={versionName}
        orderNumber={currentPage.order_number as any}
        createdAt={currentPage.created || createdAt}
        isReadOnly={true}
        isLatestDocumentVersion={isLatestDocumentVersion}
        hideCommentsButton
      />
    )
  }

  return null
}
